import React from "react";
import {faCalendarAlt, faFolderOpen, faTerminal, faUserTag, faFolderUser} from "@fortawesome/pro-solid-svg-icons";
import {Get} from "../../components/request";
import screens from "../../screens";
import {withRouter} from 'react-router-dom';
import {Alert, Col, Container, Row} from "react-bootstrap";
import UE from "../../components/ue";
import {IconTitles} from "../../components/iconTitle";
import ScreenComponent from "../../components/screenComponent";
import {faUserCheck} from "@fortawesome/sharp-solid-svg-icons";
import parse from 'react-html-parser';

class Inscription extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            inscription: {},
            UEs: [],
            deliberation: {},
            inscriptionID: -1,
            open: true,
        };
    }

    changeOpen() {
        this.setState({open: !this.state.open})
    }

    async componentDidMount() {
        super.componentDidMount();

        const id = this.props.match.params.id;
        let {body} = await Get(`/v1/extranet/student/${screens.Inscription}/${id}`);

        this.setState({
            inscription: body,
            inscriptionID: id
        });

        ({body} = await Get(`/v1/extranet/student/${screens.Inscription}01/${id}`));

        this.setState({
            UEs: this.prepareUEs(body)
        });

        ({body} = await Get(`/v1/extranet/student/${screens.Inscription}02/${id}`));

        this.setState({
            deliberation: body
        });

        //ReactDOM.findDOMNode(this.UE0.refs.Accordion).getElementsByClassName('collapse')[0].classList.add('show');
    }

    prepareUEs(body) {
        return body.filter((f) => f.ActiviteApprentissageCode === null)
        .map((m) => {
            m.AAs = body.filter((f) => f.UniteEnseignementCode === m.UniteEnseignementCode && f.ActiviteApprentissageCode !== null).map((aa) => {
                aa.isCollapsed = true;
                return aa;
            });
            return m;
        });
    }

    renderDeliberation() {
        return this.state.deliberation.Session ? (
            <>
                <Alert variant="dark">
                    <Alert.Heading className="pt-2 text-center">
                        Dernière déliberation
                        <hr/>
                    </Alert.Heading>
                    <Container>
                        <Row>
                            <Col xs={12} md={6}>
                                <div>Session de {this.state.deliberation.Session}</div>
                                <div>
                                    <u>Décision de jury</u>:&nbsp;
                                    {this.state.deliberation.DecisionJury}
                                </div>
                                {this.state.deliberation.Grade ?
                                    <div>
                                        <u>Grade</u>:&nbsp;
                                        {this.state.deliberation.Grade}
                                    </div> : ""}
                            </Col>
                            <Col>
                                <div>
                                    <u>Moyenne Générale</u>:&nbsp;
                                    {this.state.deliberation.InscriptionMoyenneGenerale}
                                </div>
                                <div>
                                    <u>Nombre de crédits validés</u>:&nbsp;
                                    {this.state.deliberation.InscriptionTotalCredits}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Alert>
                <hr/>
            </>
        ) : "";
    }

    render() {

        let header = [
            {icon: faTerminal, content: this.state.inscription.NiveauCoursLibelle},
            {icon: faCalendarAlt, content: this.state.inscription.AnneeAcademiqueValeur},
            {icon: faFolderOpen, content: this.state.inscription.StatutPAE},
            {icon: faUserTag, content: this.state.inscription.TP},
        ];

        if (this.state.inscription.AnneeAcademiqueValeur?.includes(new Date().getFullYear()) ?? false) {
            if (this.state.inscription.GestionnairesAdministratifs != null) header.push({icon: faFolderUser, content: parse("<small><u>Gestionnaire(s) administratif(s)</u></small> : " + this.state.inscription.GestionnairesAdministratifs)});
            if (this.state.inscription.Coordinateurs != null) header.push({icon: faUserCheck, content: parse("<small><u>Coordinateur(s)</u></small> : " + this.state.inscription.Coordinateurs)});
        }

        return (
            <>
                <section>
                    <IconTitles titles={header}/>
                    <hr/>
                    {this.renderDeliberation()}
                </section>
                <section>
                    <Container>
                        <Row>
                            {this.state.UEs.map((m, key) => {
                                return <UE ref={(r) => this["Ue" + key] = r} key={key} item={m}/>
                            })}
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
}

export default withRouter(Inscription);